import type { ImportedInvoice } from '../types/importedInvoice'

export const isImportedInvoiceApprovable = (invoice?: ImportedInvoice): boolean =>
  Boolean(invoice && invoice.status === 'to_review' && !invoice.approved)
